export default __webpack_public_path__ + "static/media/pen-tool.bb72d32a.svg";